import React from "react";

function ProgressBar({ steps = [], currentStep }) {
  if (!steps.length) return null;

  return (
    <div className="progress-wrapper">
      <div className="progress-container">
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const status =
            stepNumber < currentStep
              ? "completed"
              : stepNumber === currentStep
              ? "active"
              : "inactive";

          return (
            <div
              key={index}
              className={`progress-step ${status}`}
            >
              <div className="progress-circle">
                {status === "completed" ? "✓" : stepNumber}
              </div>

              <span className="progress-label">
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProgressBar;
